import React from 'react'

const PanelFFXIV = ({
    className,
    children,
}: {
    className?: string;
    children: React.ReactNode;
}) => {
    return (
        <div
            className={`relative w-fit rounded-xl p-4 shadow-[0px_0px_4px_3px_rgba(0,0,0,0.3)] text-[#DDDDDD] font-myriad leading-[18px] bg-[#323232] ${className}`}
            style={{ backgroundImage: 'url(/grid_pattern.png)', backgroundRepeat: 'repeat', backgroundSize: '5px 5px' }}
        >
            {/* Top gradient overlay */}
            <div className="absolute bg-gradient-to-b from-white to-transparent h-5 w-full top-0 left-0 pointer-events-none opacity-20 rounded-t-[10px]"></div>
            {children}
        </div>
    )
}

export default PanelFFXIV